import { CartModal } from "components/CartModal/CartModal";
import { ActionItemEntitySelector } from "components/HomeActionItems/ActionItemEntitySelector";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useState } from "react";

type CartTaskModalProps = {
  open: boolean;
  entityIds: string[];
  groupId: string;
  onClose: () => void;
};

export const CartTaskModal = ({
  open,
  entityIds,
  groupId,
  onClose,
}: CartTaskModalProps) => {
  const { entities } = useCurrentGroupContext();

  const [selectedEntity, setSelectedEntity] = useState<string | null>(null);

  const hasSingleEntity = entityIds.length === 1;
  const effectiveEntity = hasSingleEntity ? entityIds[0] : selectedEntity;
  const showSelector = open && !hasSingleEntity && !selectedEntity;
  const entityList = entities.filter((entity) =>
    entityIds.includes(entity.uuid)
  );

  const handleClose = () => {
    setSelectedEntity(null);
    onClose();
  };

  const handleSelect = (entityId: string) => setSelectedEntity(entityId);

  return (
    <>
      <ActionItemEntitySelector
        isOpen={showSelector}
        close={handleClose}
        entityList={entityList}
        context="cart"
        setSelectedEntity={handleSelect}
      />
      {open && effectiveEntity && (
        <CartModal
          open={open && Boolean(effectiveEntity)}
          onClose={handleClose}
          entityIdFromProps={effectiveEntity}
          groupIdFromProps={groupId}
          hideEntitySelector
        />
      )}
    </>
  );
};
